// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminVendors = (client) => ({
    /**
     * `POST /admin/vendors/:vendor_id/keystore/entries`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpsertVendorKeystoreEntry
     * @source packages/medusa-plugin-encrypted-store/src/api/admin/vendors/[vendor_id]/keystore/entries/route.ts
     */
    createKeystoreEntry: (vendorId, body, query, headers) => client.fetch(buildPath("/admin/vendors/:vendor_id/keystore/entries", [vendorId]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/vendors/:id/sales-managers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminVendorsIdSalesManagersCreate
     * @source apps/backend/src/api/admin/vendors/[id]/sales-managers/route.ts
     */
    createSalesManager: (id, body, query, headers) => client.fetch(buildPath("/admin/vendors/:id/sales-managers", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/vendors/:id/escalation-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminVendorsIdEscalationManagerDelete
     * @source apps/backend/src/api/admin/vendors/[id]/escalation-manager/route.ts
     */
    deleteEscalationManager: (id, body, query, headers) => client.fetch(buildPath("/admin/vendors/:id/escalation-manager", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /admin/vendors/:vendor_id/keystore/entries/:key_name`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDeleteVendorKeystoreEntry
     * @source packages/medusa-plugin-encrypted-store/src/api/admin/vendors/[vendor_id]/keystore/entries/[key_name]/route.ts
     */
    deleteKeystoreEntry: (vendorId, keyName, body, query, headers) => client.fetch(buildPath("/admin/vendors/:vendor_id/keystore/entries/:key_name", [vendorId, keyName]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /admin/vendors/:id/sales-managers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminVendorsIdSalesManagersDelete
     * @source apps/backend/src/api/admin/vendors/[id]/sales-managers/route.ts
     */
    deleteSalesManager: (id, body, query, headers) => client.fetch(buildPath("/admin/vendors/:id/sales-managers", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/vendors`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminVendorsList
     * @source apps/backend/src/api/admin/vendors/route.ts
     */
    list: (query, headers) => client.fetch("/admin/vendors", { method: "GET", query, headers }),
    /**
     * `GET /admin/vendors/:vendor_id/ai-usage/events`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListVendorAiUsageEvents
     * @source packages/medusa-plugin-ai-usage/src/api/admin/vendors/[vendor_id]/ai-usage/events/route.ts
     */
    listAiUsageEvents: (vendorId, query, headers) => client.fetch(buildPath("/admin/vendors/:vendor_id/ai-usage/events", [vendorId]), { method: "GET", query, headers }),
    /**
     * `GET /admin/vendors/:vendor_id/keystore/entries`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListVendorKeystoreEntries
     * @source packages/medusa-plugin-encrypted-store/src/api/admin/vendors/[vendor_id]/keystore/entries/route.ts
     */
    listKeystoreEntries: (vendorId, query, headers) => client.fetch(buildPath("/admin/vendors/:vendor_id/keystore/entries", [vendorId]), { method: "GET", query, headers }),
    /**
     * `GET /admin/vendors/:id/sales-managers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminVendorsIdSalesManagersRetrieve
     * @source apps/backend/src/api/admin/vendors/[id]/sales-managers/route.ts
     */
    listSalesManagers: (id, query, headers) => client.fetch(buildPath("/admin/vendors/:id/sales-managers", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/vendors/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminVendorsIdRetrieve
     * @source apps/backend/src/api/admin/vendors/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/vendors/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/vendors/:vendor_id/ai-usage`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetVendorAiUsageSummary
     * @source packages/medusa-plugin-ai-usage/src/api/admin/vendors/[vendor_id]/ai-usage/route.ts
     */
    retrieveAiUsage: (vendorId, query, headers) => client.fetch(buildPath("/admin/vendors/:vendor_id/ai-usage", [vendorId]), { method: "GET", query, headers }),
    /**
     * `GET /admin/vendors/:id/escalation-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminVendorsIdEscalationManagerRetrieve
     * @source apps/backend/src/api/admin/vendors/[id]/escalation-manager/route.ts
     */
    retrieveEscalationManager: (id, query, headers) => client.fetch(buildPath("/admin/vendors/:id/escalation-manager", [id]), { method: "GET", query, headers }),
    /**
     * `POST /admin/vendors/bulk-assign-escalation-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminVendorsBulkAssignEscalationManagerCreate
     * @source apps/backend/src/api/admin/vendors/bulk-assign-escalation-manager/route.ts
     */
    updateBulkAssignEscalationManager: (body, query, headers) => client.fetch("/admin/vendors/bulk-assign-escalation-manager", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/vendors/:id/escalation-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminVendorsIdEscalationManagerCreate
     * @source apps/backend/src/api/admin/vendors/[id]/escalation-manager/route.ts
     */
    updateEscalationManager: (id, body, query, headers) => client.fetch(buildPath("/admin/vendors/:id/escalation-manager", [id]), { method: "POST", body, query, headers }),
    /**
     * `PUT /admin/vendors/:vendor_id/keystore/entries/:key_name`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminReplaceVendorKeystoreEntry
     * @source packages/medusa-plugin-encrypted-store/src/api/admin/vendors/[vendor_id]/keystore/entries/[key_name]/route.ts
     */
    updateKeystoreEntry: (vendorId, keyName, body, query, headers) => client.fetch(buildPath("/admin/vendors/:vendor_id/keystore/entries/:key_name", [vendorId, keyName]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=vendors.js.map